import hash from "object-hash"
import { cloneDeep } from "lodash"
import ActionTypes from "../const/ActionTypes"

const initialState = {
  program: [[]],
  hash: null
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PROGRAM_SAVE: {
      const { program } = action.payload
      return {
        ...state,
        program: cloneDeep(program),
        hash: hash(program)
      }
    }

    case ActionTypes.PROGRAM_LOAD: {
      const { program } = action.payload
      return {
        ...state,
        program,
        hash: hash(program)
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/drawings.js